import React, { useEffect, useState } from 'react';
import styles from './OddBadge.module.scss';
import { renderOdd } from '../../../../../utils/render';
import { MINIMUM_ODD_VALUE } from '../../../../../constants/defaultValues';

const OddBadge = ({ bet }) => {
    const { odd, changeType } = bet;
    const isEmpty = bet.isFrozen || bet.isClosed || odd < MINIMUM_ODD_VALUE;
    const [increased, setIncreased] = useState(false);
    const [decreased, setDecreased] = useState(false);

    useEffect(() => {
        if (isEmpty || !changeType) {
            setDecreased(false);
            setIncreased(false);
            return;
        }

        if (changeType === 'increase') {
            setIncreased(true);
            setDecreased(false);
        } else if (changeType === 'decrease') {
            setDecreased(true);
            setIncreased(false);
        }

        setTimeout(() => {
            setDecreased(false);
            setIncreased(false);
        }, 5000);
    }, [odd, changeType, isEmpty]);

    return (
        <span
            className={`${styles.oddBadge} 
                ${increased ? styles.increased : ''} 
                ${decreased ? styles.decreased : ''}`}
        >
            {renderOdd({
                odd: bet.odd,
                marketStatus: bet.marketStatus,
                outcomeStatus: bet.outcomeStatus,
                isFrozen: bet.frozen,
            })}
        </span>
    );
};

export default OddBadge;
